import type { MetaFunction } from "react-router";
import BandsInTown from "../components/BandsInTown";
import SpotifyReleases from "../components/SpotifyReleases";
import YoutubeVideos from "../components/YoutubeVideos";
import ShopifyMerch from "../components/ShopifyMerch";
import ArtistHero from "../components/ArtistHero";
import NewsletterSignup from "../components/NewsletterSignup";
import Footer from "../components/Footer";

console.log('Loading home component...');

export const meta: MetaFunction = () => {
  console.log('Generating meta tags...');
  const title = "Fresku – Officiële Website";
  const description = "Luister naar zijn nieuwste muziek, bekijk zijn theatertours en shop exclusieve Fresku merchandise. Volg de ontwikkelingen van zijn label Baranka Music en blijf op de hoogte!";
  const image = "/about/01.webp"; // Replace with your actual image path

  return [
    // Basic Meta Tags
    { title },
    { name: "description", content: description },
    
    // OpenGraph Meta Tags
    { property: "og:type", content: "website" },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:image", content: image },
    { property: "og:site_name", content: "Fresku" },
    
    // Twitter Card Meta Tags
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: image },
    
    // Additional SEO Meta Tags
    { name: "robots", content: "index,follow" },
    { name: "googlebot", content: "index,follow" },
    { name: "keywords", content: "Fresku, rapper, acteur, theatermaker, Baranka Music, Nederlandse hip-hop" },
    
    // Favicon and App Icons (keeping your existing ones)
    { rel: "icon", type: "image/x-icon", href: "/favicon.ico" },
    { rel: "icon", type: "image/svg+xml", href: "/favicon.svg" },
    { rel: "apple-touch-icon", href: "/apple-touch-icon.png" },
    { rel: "manifest", href: "/site.webmanifest" },
    { rel: "icon", type: "image/png", sizes: "96x96", href: "/favicon-96x96.png" },
    { rel: "icon", type: "image/png", sizes: "192x192", href: "/web-app-manifest-192x192.png" },
    { rel: "icon", type: "image/png", sizes: "512x512", href: "/web-app-manifest-512x512.png" },
  ];
};

export default function Home() {
  console.log('Rendering Home component...');
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-screen-xl mx-auto px-0 sm:px-4">
        <ArtistHero />
        <YoutubeVideos />
        <SpotifyReleases />
        <BandsInTown />
        <ShopifyMerch />
        <NewsletterSignup />
        <Footer />
      </div>
    </div>
  );
}
